export default Object.freeze({
  CHANNEL: 'channel',
  APE_TRIAL_POPUP_SHOWED: 'ape_trial_popup_showed',
});
